import { Avatar, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { FaCloudUploadAlt } from "react-icons/fa";
import { AiOutlineUpload } from 'react-icons/ai';

import {
  userSignInAction,
  userSignUpAction,
} from "../../redux/actions/userAction";
import { useNavigate } from "react-router-dom";
import heroImage from "../../images/hero_1.jpg";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import "./register.css";

const validationSchema = yup.object({
  username: yup
    .string("Enter your name")
    .min(3)
    .max(30)
    .required("firstName is required."),
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  position: yup.string("Enter your position").required("Position is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  location: yup.string().min(3).required("location is required!"),
  whoami: yup
    .string("Enter a small description")
    .required("Who am i is required"),
  yearOfExperience: yup
    .string("Year of experience is required")
    .required("Year of experience is required"),
});

const Register = () => {
  const [image, setImage] = useState({ name: "", url: "" });
  const [pdf, setPdf] = useState({ name: "", url: "" });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, userInfo, loading } = useSelector(
    (state) => state.signUp
  );

  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      position: "",
      location: "",
      yearOfExperience: "",
      whoami: "",
      profilePic: "",
      password: "",
      confirmPassword: "",
      checkbox: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      const formData = {
        username: values.username,
        email: values.email,
        position: values.position,
        password: values.password,
        location: values.location,
        yearOfExperience: values.yearOfExperience,
        whoami: values.whoami,
        profilePic: image,
        cv: pdf,
        type: "user",
      };
      console.log(formData);
      dispatch(userSignUpAction(formData, navigate));
      // actions.resetForm();
    },
  });
  const handleImageChange = (file) => {
    if (file === undefined) {
      toast.error({
        title: "Warning",
        description: "Please select an image!",
        status: "warning",
        duration: 4000,
        isClosable: true,
        position: "bottom",
      });
      return;
    }
    // Check if the file is an image
    if (!file.type.startsWith("image/")) {
      toast.error("File is not an image");
      return;
    }
    const reader = (readFile) =>
      new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(readFile);
      });
    reader(file).then((result) => setImage({ name: file?.name, url: result }));
  };
  const handlePdfChange = (file) => {
    if (file === undefined) {
      toast.error("select a valid pdf file!");
      return;
    }
    // Check if the file is an image
    if (file.type !== "application/pdf") {
      toast.error("Please select a pdf file!");
      return;
    }
    const reader = (readFile) =>
      new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(readFile);
      });
    reader(file).then((result) => setPdf({ name: file?.name, url: result }));
  };
  console.log(loading);

  return (
    <>
      <section
        class="section-hero  inner-page"
        id="home-section"
        style={{
          backgroundColor: "rgb(64,64,64)",
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <h1
                class="text-white"
                style={{
                  fontSize: "4rem",
                  fontWeight: "400",
                }}
              >
                Register
              </h1>
              <div class="custom-breadcrumbs">
                <Link
                  style={{
                    color: "white",
                  }}
                  to="/"
                >
                  Home
                </Link>
                <span class="mx-2 slash">/</span>
                <span class="text-white">
                  <strong>Register</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <section
          style={{
            paddingBottom: "100px",
            paddingTop: "50px",
            paddingLeft: "100px",
            paddingRight: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "800px",
            placeItems: "center",
          }}
        >
          <div
            class="registerClass"
            style={{
              padding: "5%",
              boxShadow: " 5px 5px 8px #D9D9E4",
              display: "flex",
              border: '1px solid rgba(0,0,0,0.1)',
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <form class="contain-register" onSubmit={formik.handleSubmit}>
              <div class="row form-group">
                <div class="col-md-12 mb-4 mb-md-0">
                  <h2
                    class="mb-4"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Sign Up To JobBoard
                  </h2>
                  <label class="text-black" for="fname">
                    <b>Username</b>
                  </label>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    class="form-control mb-3"
                    placeholder="Enter your username"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.username}
                    style={{
                      borderColor:
                        formik.errors.username && formik.touched.username
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.username && formik.touched.username
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.username && formik.touched.username && (
                    <p style={{ color: "red" }}>{formik.errors.username}</p>
                  )}
                </div>

                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="fname">
                    <b>Email</b>
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    class="form-control mb-3"
                    placeholder="Email your email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    style={{
                      borderColor:
                        formik.errors.email && formik.touched.email
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.email && formik.touched.email
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.email && formik.touched.email && (
                    <p style={{ color: "red" }}>{formik.errors.email}</p>
                  )}
                </div>
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="position">
                    <b>Position</b>
                  </label>
                  <input
                    type="text"
                    id="position"
                    name="position"
                    class="form-control mb-3"
                    placeholder="eg: Soft eng"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.position}
                    style={{
                      borderColor:
                        formik.errors.position && formik.touched.position
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.position && formik.touched.position
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.position && formik.touched.position && (
                    <p style={{ color: "red" }}>{formik.errors.position}</p>
                  )}
                </div>
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="location">
                    <b>Location</b>
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    class="form-control mb-3"
                    placeholder="eg: Lebanon"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.location}
                    style={{
                      borderColor:
                        formik.errors.location && formik.touched.location
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.location && formik.touched.location
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.location && formik.touched.location && (
                    <p style={{ color: "red" }}>{formik.errors.location}</p>
                  )}
                </div>
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="yearOfExperience">
                    <b>Years of experience</b>
                  </label>
                  <input
                    type="text"
                    id="yearOfExperience"
                    name="yearOfExperience"
                    class="form-control mb-3"
                    placeholder="eg: 2"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.yearOfExperience}
                    style={{
                      borderColor:
                        formik.errors.yearOfExperience &&
                          formik.touched.yearOfExperience
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.yearOfExperience &&
                          formik.touched.yearOfExperience
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.yearOfExperience &&
                    formik.touched.yearOfExperience && (
                      <p style={{ color: "red" }}>
                        {formik.errors.yearOfExperience}
                      </p>
                    )}
                </div>
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="whoami">
                    <b>Who Am I</b>
                  </label>
                  <input
                    type="text"
                    id="whoami"
                    name="whoami"
                    class="form-control mb-3"
                    placeholder="small description about yourself"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.whoami}
                    style={{
                      borderColor:
                        formik.errors.whoami && formik.touched.whoami
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.whoami && formik.touched.whoami
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.whoami && formik.touched.whoami && (
                    <p style={{ color: "red" }}>{formik.errors.whoami}</p>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingLeft: "17px",
                    paddingRight: "17px",
                    width: "100%",
                  }}
                >
                  <div
                    class="contain-browse"
                    style={
                      {
                        // marginLeft:'18px'
                      }
                    }
                  >
                    <label for="company-website-tw">
                      <b>Upload your Picture </b>
                    </label>{" "}
                    <br />
                    <label
                      class="btn btn-md btn-file"
                      style={{
                        backgroundColor: "#6E3ECD",
                        color: "white",
                        borderRadius: "5px",
                      }}
                    >
                      <FaCloudUploadAlt size={22} color={"white"} />
                      <input
                        type="file"
                        onChange={(e) => handleImageChange(e.target.files[0])}
                      />
                    </label>
                  </div>
                  <div className="contain-browse">
                    <label htmlFor="company-website-tw d-block">
                      <b>Upload CV</b>
                    </label>
                    <br />
                    <label
                      className="btn btn-md btn-file"
                      style={{
                        backgroundColor: "#6E3ECD",
                        color: "white",
                      }}
                    >
                     <AiOutlineUpload color={"white"} size={22}  /> 
                      <input
                        type="file"
                        onChange={(e) => handlePdfChange(e.target.files[0])}
                        accept="application/pdf"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="password">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    class="form-control"
                    placeholder="Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    style={{
                      borderColor:
                        formik.errors.password && formik.touched.password
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.password && formik.touched.password
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.password && formik.touched.password && (
                    <p style={{ color: "red" }}>{formik.errors.password}</p>
                  )}
                </div>
              </div>
              <div class="row form-group mb-4">
                <div class="col-md-12 mb-3 mb-md-0">
                  <label class="text-black" for="fname">
                    Re-Type Password
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    id="fname"
                    class="form-control"
                    placeholder="Re-type Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                    style={{
                      borderColor:
                        formik.errors.confirmPassword &&
                          formik.touched.confirmPassword
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.confirmPassword &&
                          formik.touched.confirmPassword
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.confirmPassword &&
                    formik.touched.confirmPassword && (
                      <p style={{ color: "red" }}>
                        {formik.errors.confirmPassword}
                      </p>
                    )}
                </div>
              </div>

              <div
                class="row form-group"
                style={{
                  width: "100%",
                }}
              >
                <div
                  class="col-md-12"
                  style={{
                    width: "100%",
                  }}
                >
                  <button
                    type="submit"
                    class="btn px-4 text-white"
                    style={{
                      width: "106%",
                      backgroundColor: "#6E3ECD",
                    }}
                  >
                    {loading ? <CircularProgress /> : "Register"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};

export default Register;
